export const productUrl = 'https://run.mocky.io/v3/03edf004-a0f0-43d6-931b-d5cf991f672c';
export const galleryUrl = 'https://jsonplaceholder.typicode.com/albums/1/photos';
export const sliderUrl = 'https://run.mocky.io/v3/3c3f69d1-2618-4c1e-98d9-ea879bccb9ac';
export const baseUrl = 'https://sas-back.herokuapp.com/';
export const key = 'U2FsdGVkX1+t1C9/8qEXOTJQzAEkDG+NkagpZM3Hzvt5koLr6NnVMEb66XG3zFNo';

// http://localhost:8080/
// https://sas-back.herokuapp.com/
